import { useCallback } from 'react';
import { useGetUserLazyQuery, User } from 'gql/types';
import { Preferences } from '@capacitor/preferences';
import { PreferenceKey } from 'storage/preferences/prefKeys';

export function useFetchUserWithFallback({
    onUserLoaded,
    onLoadingState,
}: {
    onUserLoaded: (user: User | null) => void;
    onLoadingState?: (loading: boolean) => void;
}) {
    const [fetchUserQuery, { loading }] = useGetUserLazyQuery({
        fetchPolicy: 'cache-and-network',
        context: { skip401Redirect: true },
        onCompleted: async (data) => {
            const user = data?.getUser ?? null;
            if (user) {
                console.log("user fetched successfully");
                // remove faulty user object we set in previous versions
                await Preferences.remove({ key: PreferenceKey.USER });

                onUserLoaded(user);
            }
        },
        onError: async (err) => {
            console.error('Network error fetching user:', err.message);
        },
    });

    // Optional: surface loading state
    if (onLoadingState) onLoadingState(loading);

    const fetchUser = useCallback(() => {
        fetchUserQuery();
    }, [fetchUserQuery]);

    return {
        fetchUser,
        loading,
    };
}
